import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { postEndorsementFormData } from "../components/endorsement/endorsementDialogHandlers";
import {
  buildEndorsementPayloadFromState,
  executeReleaseRiderFlow,
  getReleaseRiderFlow,
  validateEndorsementSubmit,
} from "../components/endorsement/endorsementSubmitHelpers";

/** Shared endorsement submit/release handlers for law-firm dialogs and bond archives. */
export default function useBondEndorsementSubmitHandlers({
  setIsSubmittingEndorsement,
  setEndorsementDialogOpen,
  selectedBondToEndorse,
  endorsementType,
  endorsementFile,
  contactName,
  contactEmail,
  newBondAmount,
  estimatedAssets,
  endorsementToCounty,
  updatedName,
  dwbFirstName,
  dwbMiddleName,
  dwbLastName,
  dwbSuffix,
  dwbAlias,
  endorsementPrincipalId,
  role,
  refreshData,
}) {
  const navigate = useNavigate();

  const endorsementState = {
    endorsementType,
    endorsementFile,
    contactName,
    contactEmail,
    newBondAmount,
    selectedBondToEndorse,
    estimatedAssets,
    endorsementToCounty,
    updatedName,
    dwbFirstName,
    dwbMiddleName,
    dwbLastName,
    dwbSuffix,
    dwbAlias,
    endorsementPrincipalId,
  };

  const buildEndorsementPayload = () =>
    buildEndorsementPayloadFromState(endorsementState);

  const postEndorsement = async (afterSuccess) => {
    await postEndorsementFormData({
      payload: buildEndorsementPayload(),
      setSubmitting: setIsSubmittingEndorsement,
      onSuccess: async () => {
        setEndorsementDialogOpen(false);
        await refreshData();
        afterSuccess?.();
      },
    });
  };

  const handleReleaseRider = async () => {
    const flow = getReleaseRiderFlow(role, endorsementState);
    await executeReleaseRiderFlow(flow, {
      navigate,
      toast,
      postEndorsementFormData,
      setIsSubmittingEndorsement,
      setEndorsementDialogOpen,
      refreshData,
    });
  };

  const handleSubmitEndorsementRequest = async () => {
    const v = validateEndorsementSubmit(endorsementState);
    if (!v.ok) {
      toast.error(v.toastMessage);
      return;
    }
    await postEndorsement();
  };

  return {
    buildEndorsementPayload,
    postEndorsement,
    handleReleaseRider,
    handleSubmitEndorsementRequest,
  };
}
